import logo from '../../assets/logo.svg'

export default function Logo () {
  return <img src={logo} alt="K2S news CMS" />
}
